import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { EmptyEmployee, Form, IEmptyEmployee } from "./Form";
import { IPermissionProps } from "../../models/Login";

export interface IModal{
    singleData: IEmptyEmployee,
    open: boolean,
}

export const Employee = (permissions: IPermissionProps) => {
    const toast = useRef<Toast>(null);
    const [modal,setModal] = useState({singleData: EmptyEmployee, open: false} as IModal);
    const [reload, setReload] = useState(false);

    const hideDialog = () => {
        setModal({ singleData: EmptyEmployee, open: false });
    };

    return (
        <>
            { (permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>}
            <Table permissions={permissions} toast={toast} setModal={setModal} reload={reload}/>
            <Toast ref={toast} />
        </>
    );
}